import MuiChip, { ChipProps } from "@mui/material/Chip";

const Chip: React.FC<ChipProps> = MuiChip;

export type { ChipProps };

export default Chip;
